import * as React from 'react';
import { debounce } from '../../utils';
export var useDebounce = function (func, wait) {
    var funcRef = React.useRef(func);
    var cancelFunc = React.useRef(null);
    React.useEffect(function () {
        funcRef.current = func;
    }, [func]);
    React.useEffect(function () {
        return function () {
            if (cancelFunc.current) {
                cancelFunc.current();
            }
        };
    }, []);
    return React.useCallback(debounce(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return funcRef.current.apply(funcRef, args);
    }, wait, function (cancel) { return cancelFunc.current = cancel; }), []);
};
//# sourceMappingURL=index.js.map